import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  async requestPersistentStorage(): Promise<void> {
    if (!(navigator.storage && navigator.storage.persist)) {
      console.log("La API de Almacenamiento Persistente no está soportada.");
      return;
    }

    try {
      const isPersisted = await navigator.storage.persisted();
      console.log(`Almacenamiento ya persistente: ${isPersisted}`);
      if (isPersisted) return;

      const permissionGranted = await navigator.storage.persist();
      if (permissionGranted) {
        console.log("Permiso de almacenamiento persistente concedido.");
      } else {
        console.warn("Permiso de almacenamiento persistente denegado.");
      }
    } catch (error) {
      console.error("Error al solicitar almacenamiento persistente:", error);
    }
  }
}
